import Gender from "../../api/enums/Gender";
import { Invitation } from "../../types";
import { iconsImgs } from "../../utils/icons";

interface PromoterGroupGenderCountsProps {
  invitations: Invitation[];
}

const getGenderName = (gender: Gender | string): string => {
  if (typeof gender === "string") {
    return gender;
  }

  return Gender[gender];
};

const getGenderCount = (invitations: Invitation[], gender: Gender): number =>
  invitations.filter(
    (invitation) => getGenderName(invitation.gender) === Gender[gender]
  ).length;

const PromoterGroupGenderCounts: React.FC<PromoterGroupGenderCountsProps> = ({
  invitations,
}) => (
  <div className="yellowTxt greyBorder align-content-center justify-content-center d-flex col promoter-new__guest-count">
    <p className="mt-3 mb-2 promoter-new__guest-count-number">
      {getGenderCount(invitations, Gender.Female)}
    </p>
    <img src={iconsImgs.Female} alt="" className="mt-3 Icons" />
    <p className="mt-3 mb-2 promoter-new__guest-count-number">
      {getGenderCount(invitations, Gender.Male)}
    </p>
    <img src={iconsImgs.Male} alt="" className="mt-3 Icons" />
  </div>
);

export default PromoterGroupGenderCounts;
